import type { DifficultyLevel } from "./types";

export interface AsteroidSumChallenge {
  target: number;
  maxPart: number;
  fallSpeed: number;
  spawnIntervalMs: number;
  seed: number;
}

function seededRandom(seed: number): () => number {
  let s = seed;
  return () => {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

export function createAsteroidRandom(seed: number): () => number {
  return seededRandom(seed);
}

export function buildAsteroidSumChallenge(
  level: DifficultyLevel,
  challengeKey: number,
): AsteroidSumChallenge {
  const rand = seededRandom(challengeKey * 991 + level.length * 37);

  switch (level) {
    case "easy":
      return {
        target: 3 + Math.floor(rand() * 6),
        maxPart: 4,
        fallSpeed: 80,
        spawnIntervalMs: 850,
        seed: challengeKey * 991 + level.length * 37,
      };
    case "medium":
      return {
        target: 6 + Math.floor(rand() * 10),
        maxPart: 6,
        fallSpeed: 100,
        spawnIntervalMs: 650,
        seed: challengeKey * 991 + level.length * 37,
      };
    case "hard":
      return {
        target: 12 + Math.floor(rand() * 14),
        maxPart: 9,
        fallSpeed: 115,
        spawnIntervalMs: 480,
        seed: challengeKey * 991 + level.length * 37,
      };
  }
}

/** Pick the next falling asteroid value — biased toward helpful sums, always varied. */
export function pickNextAsteroidValue(
  currentSum: number,
  target: number,
  maxPart: number,
  rand: () => number,
): number {
  const remaining = Math.max(0, target - currentSum);
  const roll = rand();

  if (remaining > 0 && roll < 0.55) {
    const cap = Math.min(maxPart, remaining);
    return 1 + Math.floor(rand() * cap);
  }

  return 1 + Math.floor(rand() * maxPart);
}
